import { put, select } from 'redux-saga/effects';
import { photoCaptureDataFailureAction, photoCaptureIntelligentDocumentBatchProcessingRequestAction, photoCaptureIntelligentImageBatchProcessingRequestAction } from '../actions';
import { IntelligentPhotoCaptureEstimatorCaptureMode, PhotoCaptureImageDescription } from '../enums';
import { getAttachmentIterationInfo, getPhotoCaptureScreenName } from '../selectors';
import { attachmentIteration } from '../utilities';
/**
 * Saga to conditionally trigger batch processing based on screen name and capture mode.
 * Only processes files when in Estimator workflow.
 * Routes to upload file batch processing for UPLOAD_FILES capture mode,
 * or to image batch processing (UPDATE_PATCH + IMAGE_ANALYZER) for all other modes.
 */
export function* intelligentPhotoCaptureFileUploadListenerSaga(action) {
    try {
        const screenName = yield select(getPhotoCaptureScreenName);
        const isEstimatorWorkflow = screenName === PhotoCaptureImageDescription.SUMMARY;
        if (isEstimatorWorkflow) {
            const iterationInfoArray = yield select(getAttachmentIterationInfo);
            const currentInProgressIteration = attachmentIteration.getInProgressIteration(iterationInfoArray);
            const isUploadFilesIteration = (currentInProgressIteration === null || currentInProgressIteration === void 0 ? void 0 : currentInProgressIteration.captureMode) === IntelligentPhotoCaptureEstimatorCaptureMode.UPLOAD_FILES;
            if (isUploadFilesIteration) {
                yield put(photoCaptureIntelligentDocumentBatchProcessingRequestAction(action.payload));
            }
            else {
                yield put(photoCaptureIntelligentImageBatchProcessingRequestAction(action.payload));
            }
        }
    }
    catch (error) {
        yield put(photoCaptureDataFailureAction(error.toString()));
    }
}
//# sourceMappingURL=intelligentPhotoCaptureFileUploadListenerSaga.js.map